import React, { useEffect, useState, useRef } from 'react'
import logo from 'assets/icons/logo.svg'
import background from 'assets/images/background.png'

function HeroSection() {
  const [isVisible, setIsVisible] = useState(false)
  const sectionRef = useRef(null)

  useEffect(() => {
    const handleScroll = () => {
      if (sectionRef.current) {
        const rect = sectionRef.current.getBoundingClientRect()
        const isInView = rect.top < window.innerHeight && rect.bottom >= 0
        setIsVisible(isInView)
      }
    }

    window.addEventListener('scroll', handleScroll)
    handleScroll() // Check visibility on initial render

    return () => {
      window.removeEventListener('scroll', handleScroll)
    }
  }, [])

  return (
    <section
      id='hero-section'
      ref={sectionRef}
      className='flex min-h-[calc(100vh)] flex-col items-center justify-center bg-dark bg-cover bg-center'
      style={{ backgroundImage: `url(${background})` }}
    >
      <div className='m-4 flex flex-col items-center justify-center text-center md:m-8'>
        <figure className={isVisible ? 'animate-slide-right' : 'opacity-0'}>
          <img src={logo} alt='Logo da Macias & Cruz Advocacia Especializada' className='mb-4 w-32' />
        </figure>

        <h1
          className={`text-[2.5rem] font-medium uppercase text-white md:text-8xl ${
            isVisible ? 'animate-slide-right' : 'opacity-0'
          }`}
        >
          Macias & Cruz
        </h1>
        <h2 className={`mb-4 text-[1.5rem] text-white md:text-6xl ${isVisible ? 'animate-slide-right' : 'opacity-0'}`}>
          Advocacia Especializada
        </h2>
        <p className={`max-w-lg text-[1rem] text-white md:text-2xl ${isVisible ? 'animate-slide-right' : 'opacity-0'}`}>
          Nosso compromisso em proteger e fortalecer o seu negócio com responsabilidade e expertise.
        </p>
      </div>
    </section>
  )
}

export default HeroSection
